<template>
  <m-card-item
    icon="download"
    @click="showDialog = true"
  >
    {{ $t('exportMenu.export') }}
  </m-card-item>
  <m-dialog
    v-model:value="showDialog"
    :title="$t('exportMenu.exportFormat')"
    hide-header
    :ok-text="$t('exportMenu.export')"
    :max-width="$modalSizes.sm"
    @ok="handleExport"
    @cancel="showDialog = false"
  >
    <div class="_export-format-select">
      <div class="_export-format-select-title">
        {{ $t('exportMenu.selectExportFormat') }}
      </div>
      <m-select
        v-model:value="selectedFormat"
        :items="exportFormatOptions"
      />
    </div>
  </m-dialog>
</template>

<script setup>
import useOverlaySpinner from '@/composables/overlay-spinner';
import usePageExport from '@/composables/export/page-export';
import { computed, ref } from 'vue';
import { reportExportFormat } from 'shared/constants.json';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const { showOverlaySpinner, hideOverlaySpinner } = useOverlaySpinner();

const props = defineProps({
  page: {
    type: String,
    required: true,
  },
  gridPageId: {
    type: Number,
    default: undefined,
  },
  savedViewId: {
    type: Number,
    default: undefined,
  },
});

const emit = defineEmits(['export-requested']);

const { exportPage, exportLoading } = usePageExport();

const showDialog = ref(false);

const selectedFormat = ref(reportExportFormat.pdf);
const exportFormatOptions = computed(() => reportExportFormat.all.map((format) => ({
  text: t(`exportPage.exportFormat.${format}`),
  value: format,
})));

const handleExport = () => {
  showOverlaySpinner(t('general.exporting'));
  const printableData = {
    page: props.page,
    exportFormat: selectedFormat.value,
  };

  if (props.gridPageId) {
    printableData.gridPage = { uid: props.gridPageId };
  }

  if (props.savedViewId) {
    printableData.savedView = { uid: props.savedViewId };
  }

  exportPage(printableData).finally(() => {
    hideOverlaySpinner();
  });
  showDialog.value = false;
  emit('export-requested');
};
</script>

<style scoped lang="scss">
._export-format-select {
  display: flex;
  flex-direction: row;
  align-items: center;

  ._export-format-select-title {
    margin-right: auto;
    color: $font-color-secondary;
  }
}
</style>
